interface IFilter {
    center?: number,
    firstName?: string,
    lastName?: string,
    email?: string,
    dateOfBirth?: string,
    registrationDateFrom?: string,
    registrationDateTo?: string,
    source?: string,
    status?: string,
    primaryGoal?: number,
    registrationStatus?: number,
    referralStatus?: number
}

const initialFilter: IFilter = {
    center: -1,
    firstName: '',
    lastName: '',
    email: '',
    dateOfBirth: '',
    registrationDateFrom: '',
    registrationDateTo: '',
    source: '',
    status: '',
    primaryGoal: null,
    registrationStatus: null,
    referralStatus: null
};

export {
    IFilter,
    initialFilter
}